import controller from './asset-upload-drop-zone.controller';
import templateUrl from './asset-upload-drop-zone.component.html';

export default {
	templateUrl,
	controller
};
